export { StudentTabs } from './student-tabs';
export { StudentGeneralTab } from './student-general-tab';
export { StudentPerformanceTab } from './student-performance-tab';
